export default {
  default_browser_tag: 'FoodAmigos - Encomendar online',
  seo: {
    title: '{{name}} - encomendar comida online em {{city}}',
    description: '{{name}} em {{city}}. Menu oficial. Poupe dinheiro e encomende online.',
  },
};
